module.exports = __webpack_public_path__ + "tf.svg?eebbabd8c2002f491efdfabc420e6e0a";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/tf.svg
// module id = 1198
// module chunks = 27